export default __webpack_public_path__ + "static/media/Join.4c0c9c51.svg";